import dayjs from 'dayjs';

const COUPON_LINE_BREAK_RE = /<br\s*\/?>/gi;
const MARKETING_COUPON_DATE_FORMAT = 'MMM DD, YYYY';

export function normalizeMarketingCouponText(value?: string) {
  return (value || '')
    .replace(COUPON_LINE_BREAK_RE, ' ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function isUsefulMarketingCouponText(value: string) {
  return Boolean(value && !/undefined|null|NaN/.test(value));
}

export function getMarketingCouponDiscountLines(value?: string) {
  const rawValue = value || '';
  const explicitLines = rawValue
    .split(COUPON_LINE_BREAK_RE)
    .map((line) => normalizeMarketingCouponText(line))
    .filter(isUsefulMarketingCouponText);

  if (explicitLines.length > 1) {
    return explicitLines;
  }

  const normalizedValue = normalizeMarketingCouponText(rawValue);
  if (!isUsefulMarketingCouponText(normalizedValue)) {
    return [];
  }

  const offSuffixMatch = normalizedValue.match(/^(.+?)\s*(OFF)$/i);
  if (offSuffixMatch) {
    return [offSuffixMatch[1].trim(), offSuffixMatch[2]];
  }

  return [normalizedValue];
}

function formatMarketingCouponDate(value: unknown) {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const rawValue = typeof value === 'number' ? value : String(value).trim();
  const parsedDate =
    typeof rawValue === 'number'
      ? dayjs(rawValue > 9999999999 ? rawValue : rawValue * 1000)
      : dayjs(rawValue);

  return parsedDate.isValid() ? parsedDate.format(MARKETING_COUPON_DATE_FORMAT) : '';
}

export function getMarketingCouponDateRangeText(
  coupon: Record<string, unknown>,
  fallbackText?: string,
) {
  const timeInterval = Array.isArray(coupon.time_interval) ? coupon.time_interval : [];
  const isReceivedCoupon = Number(coupon.is_get) === 1;
  const startTime = isReceivedCoupon
    ? coupon.start_time || coupon.use_start_time
    : timeInterval[0] || coupon.use_start_time || coupon.start_time;
  const endTime = isReceivedCoupon
    ? coupon.end_time || coupon.use_end_time
    : timeInterval[1] || coupon.use_end_time || coupon.end_time;
  const formattedStartTime = formatMarketingCouponDate(startTime);
  const formattedEndTime = formatMarketingCouponDate(endTime);

  if (formattedStartTime && formattedEndTime) {
    return `${formattedStartTime} - ${formattedEndTime}`;
  }

  return normalizeMarketingCouponText(fallbackText);
}
